import { Switch, useComputedColorScheme, useMantineColorScheme } from '@mantine/core';
import { TbMoon } from 'react-icons/tb';
import { FEATURE_FLAG_NAMES, useFeatureFlag } from '../../../hooks/useFeatureFlag';
import { Row } from '../DesignSwitch/style';
import { useForcedColorScheme } from '../../../theme/forcedColorScheme';

// Dark theme, a setting kept per browser; Mantine stores it and sets data-mantine-color-scheme.
export default function ThemeSwitch() {
  const isV2UI = useFeatureFlag(FEATURE_FLAG_NAMES.V2_UI);
  const { setColorScheme } = useMantineColorScheme();
  const isDark = useComputedColorScheme('light') === 'dark';
  // A classic page is always light, so the switch would do nothing there.
  const forced = useForcedColorScheme();

  if (!isV2UI || forced) return null;

  return (
    <Row type="button" onClick={() => setColorScheme(isDark ? 'light' : 'dark')}>
      <TbMoon size={16} color="#868E96" />
      <span className="label">Dark theme</span>
      {/* The row is the control; a click on the switch's label would toggle twice. */}
      <Switch
        size="xs"
        checked={isDark}
        onChange={() => {}}
        tabIndex={-1}
        aria-hidden
        style={{ pointerEvents: 'none' }}
      />
    </Row>
  );
}
